import { createRouter, createWebHashHistory } from "vue-router";
// import { routes } from './router';

const routes = [
  {
    path: "/home",
    name: "Home",
    component: () => import("../views/Home.vue"),
  },
  {
    path: "/",
    name: "index",
    component: () => import("../views/index.vue"),
  },
  { // 登录
    path: "/login/login",
    name: "Login",
    component: () => import("../views/login/login.vue"),
  },
  { // 菜单
    path: "/menus/menus",
    name: "Menus",
    component: () => import("../views/menus/menus.vue"),
  },
  { // 大屏展示
    path: "/largeScreen/largeScreen",
    name: "LargeScreen",
    component: () => import("../views/largeScreen/largeScreen.vue"),
  },
  { // 数据查看
    path: "/dataDisplay/dataView",
    name: "DataView",
    component: () => import("../views/dataDisplay/dataView.vue"),
  },
  { // 数据报告
    path: "/dataReport/dataReport",
    name: "DataReport",
    component: () => import("../views/dataReport/dataReport.vue"),
  },
  { // 数据报告设置
    path: "/dataReport/dataReportSet",
    name: "DataReportSet",
    component: () => import("../views/dataReport/dataReportSet.vue"),
  },
  { // 数据报告详情
    path: "/dataReport/detail",
    name: "Detail",
    component: () => import("../views/dataReport/detail.vue"),
  },
  { // 项目管理 - 桥梁管理
    path: "/project/bridge/bridge",
    name: "Bridge",
    component: () => import("../views/project/bridge/bridge.vue"),
  },
  { // 项目管理 - 线路输入
    path: "/project/line/line",
    name: "Line",
    component: () => import("../views/project/line/line.vue"),
  },
  { // 项目管理 - 产品管理
    path: "/project/product/product",
    name: "Product",
    component: () => import("../views/project/product/product.vue"),
  },
  { // 项目管理 - 传感器设备
    path: "/project/sensor/sensor",
    name: "Pensor",
    component: () => import("../views/project/sensor/sensor.vue"),
  },
  { // 预警设置
    path: "/earlyWarning/earlyWarning",
    name: "EarlyWarning",
    component: () => import("../views/earlyWarning/earlyWarning.vue"),
  },
  { // 站内消息 - 预警信息
    path: "/alarms/message/message",
    name: "Message",
    component: () => import("../views/alarms/message/message.vue"),
  },
  { // 站内消息 - 消息推送
    path: "/alarms/push/push",
    name: "Push",
    component: () => import("../views/alarms/push/push.vue"),
  },
  { // 站内消息 - 历史数据
    path: "/alarms/history/history",
    name: "History",
    component: () => import("../views/alarms/history/history.vue"),
  },
  { // 系统管理 - 操作日志
    path: "/system/journal/operateLog",
    name: "Operatelog",
    component: () => import("../views/system/journal/operateLog.vue"),
  },
  { // 系统管理 - 登录日志
    path: "/system/journal/loginLog",
    name: "LoginLog",
    component: () => import("../views/system/journal/loginLog.vue"),
  },
  { // 系统管理 - 用户管理
    path: "/system/user/user",
    name: "User",
    component: () => import("../views/system/user/user.vue"),
  },
  { // 系统管理 - 角色管理
    path: "/system/role/role",
    name: "Role",
    component: () => import("../views/system/role/role.vue"),
  },
  { // 系统管理 - 部门管理
    path: "/system/department/department",
    name: "Department",
    component: () => import("../views/system/department/department.vue"),
  },
  { // 系统管理 - 菜单管理
    path: "/system/menu/menu",
    name: "Menu",
    component: () => import("../views/system/menu/menu.vue"),
  },
  { // 系统管理 - 配置
    path: "/system/configure/configure",
    name: "Configure",
    component: () => import("../views/system/configure/configure.vue"),
  },
  { // 系统管理 - 后台配置
    path: "/system/configure/basics",
    name: "Basics",
    component: () => import("../views/system/configure/basics.vue"),
  },
  { // 系统管理 - 传感器配置
    path: "/system/configure/sensor",
    name: "SensorConfig",
    component: () => import("../views/system/configure/sensor.vue"),
  },
];
// console.log(routes)
// if (routes.length == 0) {
// 	router.push({ path: '/login/login' })
// }
const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;